import {COVERGO_EU_UAT, COVERGO_SAAS_DEV, COVERGO_ASIA_QA, COVERGO_EU_PROD} from "../consts.js"

export const medihelp_uat = {
	"medihelp-studio.uat.eu.covergo.cloud": {
		appConfig: {
			tenantId: "medihelp_uat",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_EU_UAT,
		fileSystem: {
			bucketName: "covergo-euce1-uat-medihelp-uat"
		}
	},
}

export const medihelp_dev = {
	"medihelp-studio.dev.asia.covergo.cloud": {
		appConfig: {
			tenantId: "medihelp_dev",
			appId: "covergo_crm"
		},
		envConfig: COVERGO_SAAS_DEV
	}
}

export const medihelp_qa = {
	"medihelp-studio.qa.asia.covergo.cloud": {
		appConfig: {
			tenantId: "medihelp_qa",
			appId: "covergo_crm"
		},
		envConfig: COVERGO_ASIA_QA,
		fileSystem: {
			bucketName: "covergo-apse1-qa-medihelp-qa"
		}
	}
}

export const medihelp = {
	"medihelp-studio.eu.covergo.com": {
		appConfig: {
			tenantId: "medihelp",
			appId: "covergo_crm"
		},
		envConfig: COVERGO_EU_PROD,
		fileSystem: {
			bucketName: "covergo-euce1-prod-medihelp"
		}
	}
}


